//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';

//Third party libraries
import { useLocation, useNavigate } from 'react-router';
//Custom components
import Table from '@/components/UI/Table';
import { useApplicationsListContext } from '@/features/ApplicationForm/Components/ApplicationsList/ApplicationsListProvider';
//Services
import { convertEnumToText } from '@/utils';
import { CRFiltersForm } from './CRFiltersForm';

//STP Libraries

import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/constants';
//Assets and Miscellaneous
import Styles from './styles.module.css';

//Component Begin

export const CRApplicationList = () => {
  const { data, tablePagination, showFilterModal, toggleFilterModal, applyFiltersHandler } = useApplicationsListContext();

  const navigate = useNavigate();
  const location = useLocation();

  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'client',
      header: 'Client Name',
      accessorKey: 'applicationData',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        const applicationData = getValue() as any;
        const clientInformation = applicationData?.application;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{clientInformation?.name}</span>
            <span className='text-xs text-neutralColor-normal'>{clientInformation?.email}</span>
          </div>
        );
      },
    },
    {
      id: 'property-address',
      header: 'Property Address',
      accessorKey: 'applicationData',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        const applicationData = getValue() as any;
        const application = applicationData?.application;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>
              {application?.streetAddress}, {application?.city}, {application?.state}
            </span>
          </div>
        );
      },
    },

    {
      id: 'status',
      header: 'Status',
      accessorKey: 'status',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='flex items-center w-full capitalize'>
            <span className={`${Styles[getValue() as string]}`}>{convertEnumToText(getValue() as string)}</span>
          </div>
        );
      },
    },
    {
      id: 'createdAt',
      header: 'Submitted',
      accessorKey: 'createdAt',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        return <div className='flex items-center w-full capitalize'>{dayjs(getValue() as string).format(DATE_FORMAT)}</div>;
      },
    },
  ];

  return (
    <>
      <Table
        cols={tableColumns}
        tableData={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
      />

      {showFilterModal && <CRFiltersForm handleModal={toggleFilterModal} handleApplyFilter={applyFiltersHandler} />}
    </>
  );
};
